import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ItemsLoading from '../../../../components/Loaders/ItemsLoading'
import SkeletonListRow from '../../../../features/components/List/Skeleton'
import List from '../../../../features/components/List'
import PageSection from '../../../../features/components/PageSection'
import ActionsDropdown from '../../../../features/components/ActionsDropdown'

import { openForm } from '../../../../modules/actions/forms'
import {
  selfAccountsSelector,
  selfAccountsIsLoadingSelector,
  selfAccountsWasLoadedSelector,
  selfAccountsErrorSelector
} from '../../../../modules/selectors/selfAccounts'

import { PARTNER_ACCOUNT_EDIT } from '../../../../constants/forms'

import useCommonStyles from '../../../../styles/common/listPage'
import useStyles from './styles'

const PartnerAccountsList = () => {
  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const dispatch = useDispatch()

  const partnerAccounts = useSelector(selfAccountsSelector)

  const openPartnershipEditForm = useCallback(
    id => {
      dispatch(openForm({ id, formName: PARTNER_ACCOUNT_EDIT }))
    },
    [dispatch]
  )

  const getDropdownOptions = useCallback(
    id => [
      {
        text: 'Edit',
        onClickHandler: () => openPartnershipEditForm(id)
      }
    ],
    [openPartnershipEditForm]
  )

  const itemsListColumns = useMemo(
    () => [
      {
        Component: ({ icon }) =>
          !!icon && (
            <img className={classes.icon} src={icon} alt="icon" onError={i => (i.target.style.display = 'none')} />
          ),
        style: {
          maxWidth: 65,
          maxHeight: 50,
          textOverflow: 'unset'
        }
      },
      {
        headTitle: 'Name',
        field: 'name'
      },
      {
        Component: ({ id }) => <ActionsDropdown options={getDropdownOptions(id)} />,
        style: {
          maxWidth: 30
        }
      }
    ],
    [getDropdownOptions, classes]
  )

  return (
    <ItemsLoading
      className={commonClasses.itemList}
      itemsLength={partnerAccounts.length}
      SkeletonComponent={SkeletonListRow}
      skeletonProps={{
        cols: itemsListColumns
      }}
      ContentWrapper={PageSection}
      errorSelector={selfAccountsErrorSelector}
      isLoadingSelector={selfAccountsIsLoadingSelector}
      wasLoadedSelector={selfAccountsWasLoadedSelector}
      isEmptyNoDataMessage
    >
      <List cols={itemsListColumns} listData={partnerAccounts} />
    </ItemsLoading>
  )
}

export default PartnerAccountsList
